import React from "react";
import { setTitle } from "../helpers";
import { StationsList } from "./stations-list";
import "../styles/stations-page.css";

export const StationsPage: React.FC = () => {
  setTitle("Test Stations");

  return (
    <div id="stations-page">
      <StationsList />
    </div>
  );
};
